import { render, staticRenderFns } from "./sysDataDictList.vue?vue&type=template&id=ba161862&scoped=true&"
import script from "./sysDataDictList.vue?vue&type=script&lang=js&"
export * from "./sysDataDictList.vue?vue&type=script&lang=js&"
import style0 from "./sysDataDictList.vue?vue&type=style&index=0&id=ba161862&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba161862",
  null
  
)

export default component.exports